import { firebase } from '../config/configureFirebase';
import AccessKey from '../other/AccessKey';
import base64 from 'react-native-base64';

// Sends recorded audio to the transcribe_audio Cloud Function (Google
// Cloud Speech-to-Text proxy). Returns { transcript, confidence,
// languageCode } on success.
//
// Caller is responsible for passing the right encoding + sampleRateHertz
// for the audio they recorded:
//   • iOS LinearPCM 16kHz mono → encoding='LINEAR16', sampleRateHertz=16000
//   • Android AMR_WB           → encoding='AMR_WB',    sampleRateHertz=16000
//   • Web MediaRecorder webm   → encoding='WEBM_OPUS', sampleRateHertz=48000
export const transcribeAudio = async ({ audioBase64, encoding, sampleRateHertz, languageCode }) => {
  const { config } = firebase;
  const url = `https://${config.projectId}.web.app/transcribe_audio`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
    },
    body: JSON.stringify({
      audioBase64,
      encoding,
      sampleRateHertz,
      languageCode: languageCode || 'am-ET',
    }),
  });
  if (!res.ok) {
    const errBody = await res.text().catch(() => '');
    throw new Error(`Transcribe failed (${res.status}): ${errBody}`);
  }
  return await res.json();
};
